import { defineComponent as _defineComponent } from 'vue'
import BenefitsCardPlanCard from '@/components/benefits_card_plans_view/BenefitsCardPlanCard.vue';
import CommonButton from '@/components/CommonButton.vue';
import Divider from '@/components/Divider.vue';
import { BenefitsCardPlan } from '@/models/benefits_cards/benefits_card_plan_model';
import { ReqBenCardsRenewScreens, useReqRenewBenefitsCardPlansStore } from '@/stores/benefits_card_plans/request_renew_benefits_cards_plan_store';
import FormatUtils from '@/utils/format_utils';
import { inject, Ref } from 'vue';
import LoadingModalV2 from '../../LoadingModalV2.vue';
import { LoadingModalV2Injection } from '@/infra/constants/injections';
import PaymentMethodCard from '@/components/payment_method/PaymentMethodCard.vue';
import { PaymentMethodTypes } from '@/models/payment_method/payment_method_types_enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmValueScreen',
  props: {
    showScreen: { type: Boolean, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const reqRenewBenCardsPlanStore = useReqRenewBenefitsCardPlansStore;
const loadingModalV2 = inject<Ref<InstanceType<typeof LoadingModalV2>>>(LoadingModalV2Injection);



async function renewBenCardsPlan() {
  const promise = reqRenewBenCardsPlanStore.renewBenCardsPlan();
  await loadingModalV2?.value?.open({
    promise,
    loading: {
      text: 'Gerando PIX para renovação...'
    },
    loaded: {
      text: 'PIX gerado com sucesso',
      subtext: 'Redirecionando para a tela de pagamento...'
    },
  });
  const res = await promise;
  if (res.isError()) return;
  reqRenewBenCardsPlanStore.currentScreen = ReqBenCardsRenewScreens.PAYMENT;
}


const __returned__ = { reqRenewBenCardsPlanStore, loadingModalV2, renewBenCardsPlan, BenefitsCardPlanCard, CommonButton, Divider, get ReqBenCardsRenewScreens() { return ReqBenCardsRenewScreens }, get FormatUtils() { return FormatUtils }, PaymentMethodCard, get PaymentMethodTypes() { return PaymentMethodTypes } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})